<template>
  <main class="my-3">
    <div v-if="loading" id="loading" class="text-center">
      <loading></loading>
    </div>
    <section v-if="!loading">
      <subject-summary
        :activated="activatedCount"
        :enrolled="responseStudySubjects.length"
        :error="errorCount"
        :invited="invitedCount"
      ></subject-summary>
      <div>
        <b-container class="mt-1 mb-4" fluid>
          <b-card class="cardStyle" no-body>
            <div class="px-4 py-3">
              <b-row class="my-1">
                <b-col class="col-sm-6 col-md-6 col-lg-5 col-xl-5 col-12">
                  <div class="subject-search">Search</div>
                  <b-icon
                    class="position-absolute h-50 text-muted ml-2 mt-1"
                    icon="search"
                  ></b-icon>
                  <b-form-input
                    id="input-default"
                    v-model="searchQuery"
                    class="rounded-pill"
                    placeholder="Enter ID"
                    style="padding-left: 30px; background: #f4eff4"
                    type="search"
                  >
                  </b-form-input>
                </b-col>
                <b-col cols="3">
                  <div class="subject-search">Status</div>
                  <div class="input-group">
                    <b-form-select
                      id="input-user-status"
                      v-model="filters.subjectStatus"
                      :options="userStatusList"
                      class="w-75 filterClass"
                    >
                      <template #first>
                        <option value="">-- All --</option>
                      </template>
                    </b-form-select>
                  </div>
                </b-col>
              </b-row>
            </div>
            <b-table
              id="my-subject"
              :current-page="currentPage"
              :fields="fields"
              :items="filteredSubjects"
              :per-page="perPage"
              bordered
              borderless
              class="table-row-text my-team-striped"
              empty-text="There are no study Subjects."
              fixed
              hover
              primary-key="Id"
              responsive
              show-empty
              stacked="sm"
              striped
              thead-class="thMyTeam"
            >
              <template #cell(subjectStatus)="row">
                <span
                  :class="
                    row.item.subjectStatus == 'Activated'
                      ? 'badge activated'
                      : row.item.subjectStatus == 'Invitation Sent' ||
                        row.item.subjectStatus == 'Invitation Resent'
                      ? 'badge invited'
                      : row.item.subjectStatus == 'Error'
                      ? 'badge error'
                      : 'badge notinvited'
                  "
                >
                  {{ row.item.subjectStatus ? row.item.subjectStatus : 'Not Invited' }}
                </span>
              </template>

              <template #cell(invitationDate)="row">
                <span :class="!row.item.invitationDate ? 'error-text' : ''">
                  {{ row.item.invitationDate ? formatdate(row.item.invitationDate) : 'Not Sent ' }}
                </span>
              </template>

              <template #cell(activationDate)="row">
                <span :class="!row.item.activationDate ? 'error-text' : ''">
                  {{
                    row.item.activationDate ? formatdate(row.item.activationDate) : 'Not Activated'
                  }}
                </span>
              </template>
              <template #cell(actions)="row">
                <b-button
                  v-if="row.item.subjectStatus === 'Not Sent'"
                  variant="primary"
                  @click="sendInvite(row.item)"
                  >Invite now <i class="fa fa-sharp-duotone fa-solid fa-arrow-right"></i
                ></b-button>
                <b-dropdown v-else right variant="outline-primary">
                  <template #button-content>
                    <i class="fa fa-arrow-down"></i>Options
                    <!-- Three dots icon -->
                  </template>
                  <b-dropdown-item @click="showDetails(row.item)"
                    ><i class="fa fa-solid fa-list"></i> Details
                  </b-dropdown-item>

                  <b-dropdown-item v-if="row.item.subjectStatus !== 'Discontinued'" @click="reSendActivation(row.item, 'update')"
                    ><i class="fa fa-paper-plane"></i> Resend Activation Key
                  </b-dropdown-item>
                  <!-- <b-dropdown-item @click="showDetails(row.item)"><i class="fa fa-pause-circle"></i> Discontinue</b-dropdown-item> -->
                </b-dropdown>
              </template>
            </b-table>

            <div>
              <template>
                <b-container v-if="totalRecords > 0">
                  <b-row>
                    <b-col>
                      <p v-if="filteredSubjects" style="font-size: 16px">
                        <strong>{{ totalRecords }}</strong>
                        {{
                          totalRecords > 1 && totalRecords !== 0
                            ? 'Study Subjects'
                            : 'Study Subject'
                        }}
                      </p>
                    </b-col>
                    <b-col>
                      <span>
                        <label for="perPageSelector">Per page:</label>
                        <b-dropdown
                          id="perPageSelector"
                          :text="perPage.toString()"
                          variant="outline-secondary"
                        >
                          <b-dropdown-item style="pointer-events: none; opacity: 0.6"
                            >-- Select an option: --
                          </b-dropdown-item>
                          <b-dropdown-item
                            v-for="(item, idx) in perPageOptions"
                            :key="idx"
                            @click="perPage = item"
                            >{{ item }}
                          </b-dropdown-item>
                        </b-dropdown>
                      </span>
                    </b-col>
                    <b-col>
                      <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="totalRecords"
                        align="center"
                        aria-controls="study_subject-table"
                        pills
                      ></b-pagination>
                    </b-col>
                  </b-row>
                </b-container>
              </template>
            </div>
          </b-card>
        </b-container>
      </div>
      <div class="d-flex justify-content-between align-items-center mb-3">
        <b-modal
          id="show-details"
          v-model="showSubectDetails"
          class="custom-slide-modal"
          hide-footer
          hide-header
          modal-class="custom-modal-container"
          centered
        >
          <div class="details-popup" style="padding: 5px">
            <div class="sub-heading mt-2">
              Details for
              <span style="color: #0060aa">{{ SubectDetails.subjectId }}</span> Activation
            </div>
            <div style="padding-top: 8px">
              <div class="form-label">Invitation Sent On:</div>
              <span class="description"> {{ SubectDetails.invitationDate }}</span>
            </div>

            <div style="padding-top: 5px">
              <div class="form-label">Activated On:</div>
              <span class="description">{{ SubectDetails.ActivatedOn }}</span>
            </div>
            <div style="padding-top: 5px">
              <div class="form-label">Status :</div>
              <span
                :class="
                  SubectDetails.Status == 'Activated'
                    ? 'badge activated '
                    : SubectDetails.Status == 'Invitation Sent' ||
                      SubectDetails.Status == 'Invitation Resent'
                    ? 'badge invited'
                    : SubectDetails.Status == 'Error'
                    ? 'badge error '
                    : 'badge notinvited '
                "
              >
                {{ SubectDetails.Status }}</span
              >
            </div>

            <div style="padding-top: 5px">
              <div class="form-label">Last Data Sync :</div>
              <span class="description">{{ SubectDetails.lastSyncDate }}</span>
            </div>
            <div style="padding-top: 5px">
              <div class="form-label">Days Sync :</div>
              <span class="description">{{ SubectDetails.daysFromLastSync }}</span>
            </div>

            <div class="under-line mt-3"></div>
            <div class="button-align mt-3">
              <div class="close-button">
                <b-button type="button" variant="outline-primary" @click="showSubectDetails = false"
                  >Close
                </b-button>
              </div>
            </div>
          </div>
        </b-modal>
        <b-modal
          id="resend-activation"
          v-model="resentActivation"
          class="custom-slide-modal"
          hide-footer
          hide-header
          centered
          modal-class="custom-modal-container"
        >
          <div>
            <div class="sub-heading mt-2">Are you sure you want to send a new key?</div>
            <div class="description mt-3">
              By sending a new activation key, the previous key will become innactive and the data
              will continue to update from the new one.No data will be lost.
            </div>
            <div class="under-line mt-3"></div>
            <div class="button-align mt-3">
              <div class="close-button">
                <b-button type="button" variant="outline-primary" @click="resentActivation = false"
                  >Cancel
                </b-button>
              </div>
              <div class="close-button">
                <b-button
                  type="button"
                  variant="outline-primary"
                  @click="sendInvite(resendSubectActivation)"
                  >Proceed
                </b-button>
              </div>
            </div>
          </div>
        </b-modal>
        <!-- Modal for New Study Subject -->
        <b-modal
          id="new-subject-modal"
          v-model="showNewSubjectModal"
          class="custom-slide-modal"
          hide-footer
          hide-header
          modal-class="custom-modal-container"
          size="lg"
          @hide="newStudySubject.email = ''"
        >
          <form @submit.prevent="SendInvitetoSubject">
            <div>
              <div class="heading mt-2">Invite</div>
              <div class="sub-heading mt-2">
                <span>Enroll </span
                ><span style="color: #0060aa">{{ newStudySubject.subjectId }}</span
                ><span class="sub-heading"> to Apple Watch substudy for </span
                ><span class="sub-heading">{{ newStudySubject.studyId }}</span>
              </div>
              <div>
                <label class="form-label" for="activationKey"
                  ><span style="color: red">*</span>Activation Key</label
                >
                <input
                  id="activationCodeDisplay"
                  v-model="newStudySubject.activationCodeDisplay"
                  :readonly="true"
                  class="form-control ml-1"
                  required
                  type="text"
                />
              </div>

              <div class="key-desc ml-1">
                This secret key is going to be issued to the participant
              </div>
              <!-- Email ID -->
              <div>
                <label class="form-label" for="email"
                  ><span style="color: red">*</span>Participant Email</label
                >
                <input
                  id="email"
                  v-model="newStudySubject.email"
                  class="form-control ml-1"
                  placeholder="ex. john@mail.com"
                  required
                  type="email"
                />
              </div>
              <div class="key-desc ml-1">
                Add the email for this participant. The participant is going to receive an email
                with an activation key as well as a set of activation instructions for the remove
                monitoring program
              </div>

              <div>
                <input id="subjectId" v-model="newStudySubject.subjectId" type="hidden" />
                <input id="siteId" v-model="newStudySubject.siteId" type="hidden" />
                <input id="studyId" v-model="newStudySubject.studyId" type="hidden" />
                <input id="activationKey" v-model="newStudySubject.activationKey" type="hidden" />
              </div>
              <div class="description mt-3">
                The participant email is only used for sending the activation key and the activation
                instructions. The email will not be stored on any systems.
              </div>
              <div class="under-line mt-3"></div>
              <div class="button-align mt-3">
                <div class="close-button">
                  <b-button
                    type="button"
                    variant="outline-primary"
                    @click="
                      showNewSubjectModal = false;
                      newStudySubject.email = '';
                    "
                    >Cancel
                  </b-button>
                </div>
                <div class="close-button">
                  <b-button type="submit" variant="primary">Send Invitation</b-button>
                </div>
              </div>
            </div>
          </form>
        </b-modal>
      </div>
    </section>
  </main>
</template>

<script>
  import moment from 'moment/moment.js';
  import SubjectSummary from './SubjectSummary.vue';
  import axios from 'axios';

  export default {
    components: {
      SubjectSummary,
    },
    data() {
      return {
        siteId: '',
        studyId: '',
        searchQuery: '',
        responseStudySubjects: [],
        currentPage: 1,
        perPage: 5,
        perPageOptions: [5, 10, 20, 30],
        showSubectDetails: false,
        resentActivation: false,
        showNewSubjectModal: false,
        userStatusList: [
          'Not Sent',
          'Invitation Sent',
          'Invitation Resent',
          'Activated',
          'Error',
          'Discontinued',
        ],
        loading: false,
        operation: 'invite',
        newStudySubject: {
          subjectId: '',
          siteId: '',
          studyId: '',
          userStatus: '',
          activationKey: '',
          activationCodeDisplay: '',
          email: '',
        },
        SubectDetails: {
          id: 'show-details',
          invitationDate: '',
          ActivatedOn: '',
          Status: '',
          lastSyncDate: '',
          daysFromLastSync: '',
        },
        resendSubectActivation: {
          id: 'resend-activation',
        },
        filters: {
          subject: '',
          subjectStatus: '',
        },
        fields: [
          {
            key: 'subject',
            label: 'Participant ID',
            sortable: true,
          },
          {
            key: 'subjectStatus',
            label: 'Activation Status',
            sortable: true,
          },
          {
            key: 'invitationDate',
            label: 'Sent',
            sortable: true,
          },
          {
            key: 'activationDate',
            label: 'Activated',
            sortable: true,
          },
          {
            key: 'actions',
            label: 'Actions',
            sortable: false,
          },
        ],
      };
    },

    computed: {
      invitedCount: function() {
        return this.responseStudySubjects.filter(function(subject) {
          return (
            subject.subjectStatus === 'Invitation Sent' ||
            subject.subjectStatus === 'Invitation Resent'
          );
        }).length;
      },
      activatedCount: function() {
        return this.responseStudySubjects.filter(function(subject) {
          return subject.subjectStatus === 'Activated';
        }).length;
      },
      errorCount: function() {
        return this.responseStudySubjects.filter(function(subject) {
          return subject.subjectStatus === 'Error';
        }).length;
      },
      totalRecords() {
        return this.filteredSubjects.length; // Total number of filtered records
      },
      startRecord() {
        return (this.currentPage - 1) * this.perPage + 1;
      },
      endRecord() {
        return Math.min(this.startRecord + this.perPage - 1, this.totalRecords);
      },
      totalPages() {
        return Math.ceil(this.totalRecords / this.perPage); // Total number of pages
      },

      filteredSubjects() {
        const query = this.searchQuery.toLowerCase(); // Global search query
        return this.responseStudySubjects.filter(subject => {
          const matchesGlobalSearch = query
            ? Object.values(subject).some(value =>
                value
                  ?.toString()
                  .toLowerCase()
                  .includes(query),
              )
            : true;

          const matchesFieldFilters = this.filters.subjectStatus
            ? subject.subjectStatus?.toLowerCase() === this.filters.subjectStatus.toLowerCase()
            : true;
          return matchesGlobalSearch && matchesFieldFilters;
        });
      },
    },
    methods: {
      formatdate(date) {
        if (date == null || date === '') {
          return '';
        } else {
          return moment(date).format('DD MMM YYYY h:mm A');
        }
      },
      showDetails(item) {
        this.showSubectDetails = true;
        this.SubectDetails.subjectId = item.subject;
        this.SubectDetails.invitationDate = item.invitationDate
          ? moment(item.invitationDate).format('DD MMM YYYY h:mm A')
          : 'Not Sent';
        this.SubectDetails.ActivatedOn = item.activationDate
          ? moment(item.activationDate).format('DD MMM YYYY h:mm A')
          : '--';
        this.SubectDetails.Status = item.subjectStatus;
        this.SubectDetails.lastSyncDate = item.lastSyncDate
          ? moment(item.lastSyncDate).format('DD MMM YYYY h:mm A')
          : '';
        this.SubectDetails.daysFromLastSync = item.daysFromLastSync;
      },

      reSendActivation(item) {
        this.resentActivation = true;
        (this.operation = 'reinvite'), (this.resendSubectActivation = item);
      },

      async sendInvite(item) {
        this.showNewSubjectModal = true;
        this.resentActivation = false;
        this.newStudySubject.subjectId = item.subject;
        this.newStudySubject.studyId = item.studyId;
        this.newStudySubject.siteId = item.siteId;
        this.newStudySubject.activationKey = Math.random()
          .toString(36)
          .slice(2);
        var str = this.newStudySubject.activationKey;
        str = str.replace(/^.{5}/g, '*****');
        this.newStudySubject.activationCodeDisplay = str;
      },

      async getAllStudySubjects() {
        try {
          this.loading = true;
          let response = await axios.get(
            `/api/get-study-subjects?studyId=${this.studyId}&siteId=${this.siteId}`,
          );
          if (response.status === 200) {
            if (response.data['items'].length > 0) {
              this.responseStudySubjects = response.data['items'];
            } else {
              this.responseStudySubjects = [];
            }
          }
        } catch (error) {
          this.$bvToast.toast(`Server is not responding, please try again later`, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true,
            variant: 'danger',
          });
        }
        this.loading = false;
      },

      async SendInvitetoSubject() {
        try {
          const payload = {
            activationKey: this.newStudySubject.activationKey,
            email: this.newStudySubject.email,
            subjectId: this.newStudySubject.subjectId,
            siteId: this.newStudySubject.siteId,
            studyId: this.newStudySubject.studyId,
            operation: this.operation,
          };
          const response = await axios.patch('/api/send-invite-study-subject', payload);
          if (response.status === 200) {
            this.showNewSubjectModal = false; // Close the modal
            this.resetNewSubjectForm(); // Reset the form
            this.showMsgBoxTwo();
            this.getAllStudySubjects(); // Refresh the subject  list
          } else {
            alert(response.data.message || 'Failed to send invitation.');
          }
        } catch {
          alert('An error occurred while sending Invite.');
        }
      },
      async resetNewSubjectForm() {
        this.newStudySubject.email = '';
      },
      showMsgBoxTwo() {
        this.boxTwo = '';
        this.$bvModal
          .msgBoxOk('Invitation has been sent', {
            title: 'Success!',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'primary',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          })
          .then(value => {
            this.boxTwo = value;
          })
          .catch(err => {
            // An error occurred
          });
      },
    },
    async created() {
      this.studyId = this.$route.params['studyId'];
      this.siteId = this.$route.params['siteId'];
      await this.getAllStudySubjects();
    },
  };
</script>

<style scoped>
  .key-desc {
    flex: 1 1 0;
    color: #98a2b3;
    font-size: 14px;
    font-weight: 400;
  }

  .error-text {
    color: rgb(245, 27, 12);
    font-size: 14px;
    font-weight: 400;
  }

  .heading {
    height: 31px;
    padding-top: 2px;
    color: #0060aa;
    font-size: 30px;
    font-weight: 500;
    line-height: 36px;
    gap: 8px;
  }

  .sub-heading {
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0.25px;
    color: #6f6f6f;
  }

  .description {
    align-self: stretch;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.5px;
    font-feature-settings: 'case' on;
    color: #6f6f6f;
  }

  .under-line {
    width: 100%;
    height: 100%;
    border: 1px #e7e0ec solid;
  }

  .button-align {
    width: 100%;
    height: 100%;
    justify-content: space-between;
    align-items: flex-start;
    display: inline-flex;
  }

  .close-button {
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .subject-search {
    width: 60px;
    height: 22px;
    font-style: normal;
    padding-bottom: 30px;
    font-weight: 500;
    font-size: 16px;
  }

  .activated {
    display: flex;
    align-items: center;
    padding: 4px 8px;
    color: #ffffff;
    gap: 4px;
    width: 70px;
    height: 28px;
    background: #28a745;
    border-radius: 4px;
  }

  .invited {
    display: flex;
    align-items: center;
    padding: 4px 8px;
    gap: 4px;
    width: 120px;
    height: 28px;
    background: #ffc107;
    border-radius: 4px;
  }

  .error {
    display: flex;
    align-items: center;
    padding: 4px 8px;
    gap: 4px;
    width: 48px;
    height: 28px;
    background: #dc3545;
    color: #ffffff;
    border-radius: 4px;
  }

  .notinvited {
    display: flex;
    align-items: center;
    padding: 4px 8px;
    gap: 4px;
    width: 86px;
    height: 28px;
    background: #eaecf0;
    border-radius: 4px;
  }

  .filterClass {
    height: 35px;
    background: #f4eff4;
    border-radius: 30px;
  }

  .form-label {
    color: #6f6f6f;
    font-size: 14px;
    font-weight: 600;
    line-height: 14.4px;
    padding: 1px;
  }

  .form-control {
    font-size: 14px;
    padding: 1px;
    border-radius: 5px;
    color: #6f6f6f;
  }

  /* Responsive Table Styling */
  .b-table {
    width: 100%;
    overflow-x: auto;
  }

  /* Align arrow and text in the same row */
  .d-flex.align-items-center {
    display: flex;
    align-items: center;
  }

  .table > thead {
    vertical-align: bottom;
    background-color: aliceblue !important;
  }

  .justify2 {
    background-color: white;
    padding: 12px;
  }

  .custom-table {
    background-color: #fff !important;
  }

  /* Override the default background color for head-variant="light" */
  .b-table thead {
    background-color: #f3f3f3 !important;
    /* Set to your desired background color */
    color: #495057;
    /* Adjust text color for contrast */
    font-weight: bold;
    text-align: center;
  }

  /* Optional: Adjust border and padding for a cleaner look */
  .b-table thead th {
    border: 1px solid #f3f3f3 !important;
    /* Light gray border for separation */
    padding: 10px;
    /* Add padding for better spacing */
  }
</style>
